var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shieldMain"},[_c('div',{staticClass:"vip"},[_c('p',[_vm._v("查看价值数据")]),_c('p',[_vm._v("尽在高级权限")]),_c('div',[_c('el-button',{staticClass:"dialog-tologin",on:{"click":_vm.vip}},[_vm._v("升级SVIP")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }